<template>
<div role="dialog" class="layerbook-wrap" v-if="previewVisible" @click.self="closePopupLayer">
    <div class="message-preview layerbook">
        <!--  -->
        <div class="layerbook-header pc-none">
            <h3 class="title">미리보기</h3>
            <button type="button" class="layerbook-close" aria-label="닫기" @click="closePopupLayer">
                <IconBack />
            </button>
        </div>

        <!-- PC향 팝업 닫기 버튼 -->
        <button type="button" class="close-x" @click.prevent="closePopupLayer" aria-label="미리보기 닫기">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 1.91357L17.0864 0L9.5 7.58643L1.91357 0L0 1.91357L7.58643 9.5L0 17.0864L1.91357 19L9.5 11.4136L17.0864 19L19 17.0864L11.4136 9.5L19 1.91357Z" fill="#323232"/>
            </svg>
        </button>

        <!-- 아이폰 프레임(PC향) -->
        <div class="preview-frame">
            <img class="preview-frame-img" src="@/assets/img/mobile-frame.png" alt="아이폰 프레임">
            <div class="preview-body">
                <div class="iphone-header">
                    <!-- <div class="title">미리보기</div> -->
                    <div class="call-profile">
                        <svg aria-label="문자메시지 미리보기 예시 프로필" width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="18" cy="18" r="18" fill="#F9F9F9"/>
                            <mask id="mask0_4618_23869" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="36">
                            <circle cx="18" cy="18" r="18" fill="#F9F9F9"/>
                            </mask>
                            <g mask="url(#mask0_4618_23869)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4862 22.3361C21.7116 22.3361 24.3241 19.7331 24.3241 16.5194C24.3241 13.3057 21.7116 10.7027 18.4862 10.7027C15.2608 10.7027 12.6484 13.3057 12.6484 16.5194C12.6484 19.7331 15.2608 22.3361 18.4862 22.3361ZM29.4654 29.1481C31.6676 31.2526 33 33.9975 33 37C33 43.6274 26.5081 49 18.5 49C10.4919 49 4 43.6274 4 37C4 34.0425 5.29278 31.3349 7.43619 29.2431C8.07744 28.3567 9.15966 27.617 10.4373 27.0247C12.7427 25.7459 15.5161 25 18.5 25C21.5467 25 24.3739 25.7776 26.7076 27.1061C27.8647 27.6626 28.8474 28.3434 29.4654 29.1481Z" fill="#CDCDCD"/>
                            </g>
                        </svg>
                    </div>
                    <!-- <div class="call-num">1588-5639</div> -->
                </div>
                <div class="preview-content">
                    <div class="preview-date">
                        문자 메시지<br>1월 31일 (월) 오후 2:00
                    </div>
                    <template v-if="mmsImage !== 'NONE'">
                        <div class="preview-img bubble">
                            <figure>
                                <img :src="mmsImage" alt="쿠폰 이미지">
                            </figure>
                        </div>
                    </template>
                    <div class="preview-txt bubble">
                        <!-- 발송 제목 -->
                        <div class="mms-title"><strong>{{mmsTitle}}</strong></div>
                        <div class="mms-content">
                            <div>[Web발신]</div>
                            <!-- 사용자 메시지 작성 -->
                            <!-- <div class="free-txt">
                                {{messageContent}}
                            </div> -->
                            <!-- 쿠폰 고정 정보 -->
                            <div class="fix-txt" v-html="mmsContent"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 테스트 발송 -->
        <div class="mms-test device-fixed-bottom">
            <!-- 닫혀있는 번호 입력란 -->
            <div id="minimum-wrap" class="minimum-wrap" :class="{minimum : minimumHas}">
                <BtnMinimum @click.native="minimumToggle"></BtnMinimum>
                <div class="minimum-target">
                    <input type="tel" class="form-control" @keypress.enter="sendTestMms" id="testMmsMobile" v-model="testMmsMobile" placeholder="휴대폰번호(-없이 입력)">
                </div>
            </div>
            <!-- 버튼 -->
            <div class="product-order-btns">
                <button type="button" class="btn-l btn-p" @click="sendTestMms">테스트 발송</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'message-preview',

    components: {
        IconBack: () => import('@/components/svg-icon/IconBack.vue'),   // 뒤로가기 아이콘
        BtnMinimum: () => import('@/components/tiny-element/BtnMinimum.vue'), // 모바일 하단고정영역 열고 닫기 버튼
    },

    data() {
        return {
            product: [],
            useInfoTxt: null,
            goodsInfoTxt: null,
            testMmsMobile: null,
            minimumHas: true,       // 하단 영역 최소화 여부
        }
    },
    
    props: {
        previewVisible: {
            type: Boolean,
            require: true,
            default: false
        },
        title: {
            type: String,
            require: false,
        },
        scrollY : {
            type: Number,
            require: true,  
        },
        messageTitle: {
            type: String,
            require: true,
        },
        messageContent: {
            type: String,
            require: true,
        },
        mmsTitle: {
            type: String,
            require: true,
        },
        mmsContent: {
            type: String,
            require: true,
        },
        mmsImage: {
            type: String,
            require: true
        },
        productItem: {
            type: Object,
            require: true
        }
    },

    computed: {
        ...mapState({
            userData: state => state.userData,
			userNo: state => state.userNo,
            authentication: state => state.authentication,
            eventId: state => state.eventId,
            goodsId: state => state.goodsId,
        })
    },

    methods: {
        closePopupLayer() {
            this.$emit('update:previewVisible', false);
            this.restoreBodyScroll();
        },

        // 이중스크롤 방지 해제
        restoreBodyScroll(){ 
            document.body.classList.remove('body-not-scroll');  // 이중 스크롤 방지용 body 클래스 제거
            window.scrollTo({top: this.scrollY});               // 원래 위치값으로 이동
        },


        // 모바일 하단 영역 토글 버튼
        minimumToggle(){
            this.minimumHas ? this.minimumHas = false : this.minimumHas = true;
            // document.getElementById('testMmsMobile').focus(); // 모바일 UX에서 focus 매서드가 위치를 고정시켜 이후 키패드가 올라올때 가리게 되는 이슈
        },

        sendTestMms() {
            if(!this.testMmsMobile) {
                if (window.innerWidth >= 1200) { // pc
                    alert('휴대폰번호를 입력하여 주십시오.');
                    document.getElementById('testMmsMobile').focus();
                }
                this.minimumHas = false; // 최소화 영역 오픈
                // document.getElementById('testMmsMobile').focus();  // 모바일 UX에서 focus 매서드가 위치를 고정시켜 이후 키패드가 올라올때 가리게 되는 이슈
                return;
			} else if(!this.messageTitle || !this.messageContent) {
                alert('메시지 제목과 내용을 입력하여 주십시오.');
                return;
            } else {
                this.dispatchSendTestMMsApi();
            }
        },

        async dispatchSendTestMMsApi() {
            try {
                const data = {
                    goodsId: this.productItem.goodsId ,
                    messageTitle: this.messageTitle ,
                    messageContent: this.messageContent ,
                    receivermobile: this.testMmsMobile ,
                    userNo: this.userNo
                }
                await this.$store.dispatch('orderStore/actionsSendTestMMsApi', data);
                alert('테스트 발송이 완료되었습니다.')
                // this.$emit('update:previewVisible', false)
                this.testMmsMobile = null;  // 폰번호 초기화
                this.minimumHas = true;     // 하단 최소화 초기화
            } catch(err) {
                alert(err.response.data.message);
                return;
            }
        }
    },
}
</script>

<style lang="scss" scoped>

@import '@/assets/css/order.scss';
@import '@/assets/css/layerpopup.scss';
.layerbook-wrap{
    z-index: 10005;
    width: 100%;
    height: 100%;
}

.layerbook{

    &.message-preview{
        width: 100%;
        max-width: 100%;
        display: flex;
        max-height: 100%;
        overflow: auto;

        .close-x{
            align-self: flex-end;
        }
        
        @media (min-width: 1200px) {
            max-width: 380px;
            max-height: max-content;
            width: auto;
            min-width: auto;
            max-height: fit-content;
            background: none;
            display: flex;
            justify-content: center;
            padding: var(--container-padding);
        }
    }
}
.preview-frame{
    position: relative;
    .preview-frame-img{
        width: 100%;
    }
}
.preview-body{
    width: 100%;

    @media (min-width: 1200px) {
        // padding-top: calc(821/406 * 100%); // 이미지 높이 ÷ 이미지 가로 × 100 %
        padding: 0;
        border: 20px dashed transparent;
        border-top: none;
        background-clip: border-box;
        border-radius: 55px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        box-sizing: border-box;
        position: absolute;
        top:0;
        height: 100%;
    }
    

    .iphone-header{
        width: 100%;
        border-bottom: 1px solid var(--gray-30);
        text-align: center;
        padding-top: 16%; // 16%
        padding-bottom: 5px;

        .title{
            font-size: var(--order-label-font-size);
            font-weight: 600;
            height: var(--header-height);
        }

        .call-profile{
            img{
                width: 30px;
            }
            svg{
                border: 2px solid var(--gray-30);
                border-radius: 50%;
            }
        }

        .call-num{
            padding-top: 5px;
            font-size: 10px;
            color: var(--gray-08);
        }
    }    
    .preview-content{
        width: 100%;
        background: #fff;
        flex: 1 auto;
        overflow-y: auto;
        padding: 10px 20px;

        .preview-date{
            text-align: center;
            font-size: 11.5px;
            color: var(--gray-40);
            letter-spacing: 0;
            margin-bottom: 10px;
        }
    }
}
.bubble{
    background: #e9e9eb;
    border-radius: 16px;
    margin-bottom: 10px;
    margin-right: 2em;
    padding: 10px 15px;
    font-size: 14px;
    position: relative;
    max-width: 250px;

    @media (min-width: 1200px) {
        max-width: 100%;
    }

    strong{
        font-weight: 500;
    }

    &::before{
        content: '';
        display: block;
        width: 0px;
        height: 0px;
        border-right: 40px solid #e9e9eb;
        border-top: 15px solid transparent;
        // border-bottom-right-radius: 1px;
        position: absolute;
        bottom: 0;
        left: -10px;
    }
}
.preview-img.bubble{
    padding: 0;
    figure{        
        border-radius: 16px;
        overflow: hidden;
        position: relative;
        min-height: 100px;
    }
    img{
        width: 100%;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
    }
    &::before{
        display: none;
    }
}
.mms-test{
    @media (min-width: 1200px) {
        margin-top: var(--form-item-margin);
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: var(--compo-form-inline-pd);

        .btn-l{
            height: var(--form-item-height);
            font-weight: 500;
        }
        .product-order-btns{
            padding: 0;
            flex: none;
            // margin-top: var(--form-item-margin);
        }
    }
}
@media (max-width: 1200px) { /* PC향이 아닌 디바이스에서만 반영 */
    .close-x{
        display: none;
    }
    .preview-frame{
        padding-bottom: 116px; // 하단 고정값
        // max-height: fit-content;
        overflow: auto;
    }
    .preview-frame-img{
        display: none;
    }
    .iphone-header{
        display: none;
    }
}
</style>